import { createContext, useContext } from 'react';

import type { PropsWithChildren } from 'react';
import type { PickerConfig } from './PickerConfig';

const PickerConfigContext = createContext<PickerConfig | undefined>(undefined);

interface PickerConfigProviderProps extends PropsWithChildren {
  pickerConfig: PickerConfig;
}

/** 기간 Picker만 사용하는 calendar 설정 provider */
export function PickerConfigProvider({ children, pickerConfig }: PickerConfigProviderProps) {
  return <PickerConfigContext value={pickerConfig}>{children}</PickerConfigContext>;
}

export const usePickerConfig = () => useContext(PickerConfigContext);
